import Chip from '@mui/material/Chip'
import { Theme, styled } from '@mui/material/styles'
import { SxProps } from '@mui/system'
import { useTranslation } from 'react-i18next'

const MediumChip = styled(Chip)(({ theme }) => ({
  height: 12,
  width: 12,
  borderRadius: '50%',
  outline: `3px solid ${theme.palette.grey[50]}`,
  '&.MuiChip-colorPrimary': {
    backgroundColor: theme.palette.success.main
  },
  '&.MuiChip-colorSecondary': {
    backgroundColor: theme.palette.warning.main
  }
}))

const SmallChip = styled(Chip)(({ theme }) => ({
  height: 12,
  width: 12,
  borderRadius: '50%',
  backgroundColor: theme.palette.grey[300],
  color: theme.palette.common.white,
  '&.MuiChip-colorPrimary': {
    backgroundColor: theme.palette.success.main
  },
  '&.MuiChip-colorSecondary': {
    backgroundColor: theme.palette.warning.main
  }
}))

const NoSizeChip = styled(Chip)(({ theme }) => ({
  height: 20,
  width: 'auto',
  borderRadius: 5,
  backgroundColor: theme.palette.grey[300],
  color: theme.palette.common.white,
  '&.MuiChip-colorPrimary': {
    backgroundColor: theme.palette.success.main
  },
  '&.MuiChip-colorSecondary': {
    backgroundColor: theme.palette.warning.main
  }
}))

const VALID_COLORS = ['default', 'primary', 'secondary', 'error', 'info', 'success', 'warning']

export default function CustomChip({ type, status, custom, label, color, size = '' }: any) {
  const { t } = useTranslation(['global'])
  const validLabel = typeof label === 'string' ? label : ''

  const getLabel = () => {
    if (type === 0) {
      return status === 0 ? 'Borrador' : 'Publicado'
    }
    if (type === 1) {
      return status === 0 ? t('active') : t('inactive')
    }
    return validLabel
  }

  const getColor = () => {
    let selectedColor = 'default'

    if (type === 0) {
      selectedColor = status === 0 ? 'default' : 'primary'
    } else if (type === 1) {
      selectedColor = status === 0 ? 'primary' : 'secondary'
    } else if (color && VALID_COLORS.includes(color)) {
      selectedColor = color
    }

    return selectedColor
  }

  const chipProps = {
    label: getLabel() || '',
    color: getColor() as 'default' | 'primary' | 'secondary' | 'error' | 'info' | 'success' | 'warning'
  }

  if (size === 'medium') {
    return <MediumChip {...chipProps} />
  }
  if (size !== '') {
    return <SmallChip {...chipProps} />
  }

  if (custom === 'new' || custom === 'client') {
    const customStyles: SxProps<Theme> = {
      ...(custom === 'new'
        ? {
            borderRadius: 4,
            height: 20,
            backgroundColor: (theme: Theme) => theme.palette.primary.main,
            float: 'right',
            position: 'relative',
            right: '36px',
            bottom: '10px',
            '& span': {
              fontSize: '0.875rem',
              color: (theme: Theme) => theme.palette.common.white
            }
          }
        : {
            color: (theme: Theme) => theme.palette.primary.light,
            backgroundColor: (theme: Theme) => theme.palette.common.white,
            border: (theme: Theme) => `1px solid ${theme.palette.primary.light}`
          })
    }

    return <NoSizeChip label={chipProps.label} sx={customStyles} />
  }

  return <NoSizeChip {...chipProps} />
}
